import React from 'react';
import { IContent } from '../../../types';
import { withContent } from '../../../hoc/withContext';
import './Card.scss';

// @ts-ignore
import Fade from 'react-reveal/Fade';
import BackgroundImage from '../../Elements/Image/BackgroundImage';

interface ICardProps {
  context?: IContent;
  info: {
    title: string;
    description: string;
    image: string;
  };
  index: number;
}

const Card = ({ context, info, index }: ICardProps) => {
  const { title, description } = info;
  const bgImagePath = BackgroundImage({
    imageName: `bg-card-${index}`,
    extension: "jpg",
    useOnlyFallback: true
  });
  return (
    <Fade delay={index * 200} bottom duration={600} distance="10px">
      <li className="product-card">
        <div className="product-card-container">
          <div className="product-card-background" style={{ backgroundImage: `url(${bgImagePath})` }} />
          <div className="product-card-content">
            <div className="product-card-title">{title}</div>
            <div className="product-card-description-content">{description}</div>
          </div>
        </div>
      </li>
    </Fade>
  );
};

export default withContent(Card);
